import { render, staticRenderFns } from "./ShippingLocalDocumentEmergency.vue?vue&type=template&id=72d6788b&scoped=true"
import script from "./ShippingLocalDocumentEmergency.vue?vue&type=script&lang=js"
export * from "./ShippingLocalDocumentEmergency.vue?vue&type=script&lang=js"
import style0 from "./ShippingLocalDocumentEmergency.vue?vue&type=style&index=0&id=72d6788b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6788b",
  null
  
)

export default component.exports